export default __webpack_public_path__ + "static/media/search.bf3cbe10.png";